import { useState } from "react";

export const faqs = [
  {
    question: "Peut-on réparer un moteur Profalux ou faut-il obligatoirement le changer ?",
    answer: "Dans de nombreux cas, une réparation est possible. Si la panne provient d'une interruption des fils conducteurs dans les lames, d'un mauvais contact électrique, d'un condensateur défectueux ou d'un problème de programmation radio, nous réparons le composant concerné sans toucher au moteur. En revanche, si le moteur tubulaire est grippé, si l'électronique embarquée est grillée ou si le rotor est bloqué mécaniquement, le remplacement complet est la solution la plus durable. Notre diagnostic sur place détermine immédiatement la voie la plus économique.",
  },
  {
    question: "Quel est le prix d'un remplacement de moteur Profalux ?",
    answer: "Le tarif dépend du modèle de moteur, de sa puissance et de la configuration électrique de votre installation. Un moteur Profalux compatible avec les lames conductrices WireFree représente un coût légèrement supérieur à un moteur filaire standard. Nous établissons un devis gratuit et transparent avant toute intervention, sans mauvaise surprise. Le diagnostic initial est offert et vous permet de connaître précisément les options disponibles ainsi que leur tarif respectif.",
  },
  {
    question: "Combien de temps dure l'intervention de remplacement ?",
    answer: "La plupart des remplacements de moteur Profalux sont réalisés en une seule visite d'environ 1h30 à 2h30. Cette durée inclut le diagnostic, la dépose du tablier, le remplacement du moteur, la reconnexion des lames conductrices, la reprogrammation radio, le réglage des fins de course et les tests finaux. Si le moteur doit être commandé spécifiquement, nous vous donnons un délai d'approvisionnement et fixons un rendez-vous d'installation dès réception de la pièce.",
  },
  {
    question: "Gardez-vous mes télécommandes Profalux existantes ?",
    answer: "Oui, nous faisons tout pour conserver vos télécommandes existantes. Lorsque nous installons un moteur compatible avec le protocole radio Profalux, nous reprogrammons simplement les émetteurs déjà en votre possession. Si le modèle de remplacement nécessite un changement de protocole, nous vous proposons soit de migrer vers une télécommande universelle, soit de conserver vos anciennes télécommandes en parallèle. Nous vous expliquons toujours les options avant de procéder.",
  },
];

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="bg-brand-light py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-8">
          Questions fréquentes sur le moteur Profalux
        </h2>
        <div className="space-y-4">
          {faqs.map((item, i) => (
            <div
              key={i}
              className="bg-white border border-brand-border rounded-xl overflow-hidden"
            >
              <button
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between p-5 md:p-6 text-left"
              >
                <span className="text-brand-blue font-semibold text-base md:text-lg pr-4">
                  {item.question}
                </span>
                <span className="w-8 h-8 flex items-center justify-center text-brand-cyan flex-shrink-0">
                  <i
                    className={`${open === i ? "ri-subtract-line" : "ri-add-line"} text-xl`}
                  ></i>
                </span>
              </button>
              {open === i && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-brand-text leading-relaxed text-sm md:text-base">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}